<script>
import constants from '@/libs/Constants';
import Pixel from "@/components/Pixel.vue";
import {flagUsePixel} from "@/libs/Helpers";
import plausible from "@/libs/PlausibleTracker";

export default {
  name: 'TermsView',
  components: {Pixel},
  data() {
    // Retrieve list of contacts from environment variables
    let privacyEmailList;
    try {
      privacyEmailList = JSON.parse(process.env.VUE_APP_TERMS_OF_SERVICE_PRIVACY_EMAIL_LIST);
    } catch (error) {
      privacyEmailList = [];
    }

    return {
      constants,
      loginLink: constants.ROUTING.LANDING,
      privacyLink: constants.ROUTING.PRIVACY,

      //Configuration from environment variables
      domain: process.env.VUE_APP_PRIVACY_DOMAIN,
      privacyEmail: privacyEmailList,
      privacyEmailSubject: process.env.VUE_APP_TERMS_OF_SERVICE_PRIVACY_EMAIL_SUBJECT
    }
  },
  methods: {
    flagUsePixel
  },
  mounted() {
    plausible.trackPageview();
  }
}
</script>

<template>
  <main class="flex-shrink-0 m-4 p-2">
    <div class="container">
      <div class="row">
        <div class="col-12 offset-0 col-sm-10 offset-sm-1">
          <div class="row">
            <div class="col-sm-6 offset-sm-3 col-12 offset-0 text-center">
              <router-link :to="{name: loginLink}">
                <img src="@/assets/img/logos/logo.png" alt="Logo" height="80" class="d-inline-block align-top"/>
              </router-link>
            </div>
          </div>
          <h2 class="text-blue mt-4 text-center">Website Terms and Conditions</h2>
          <p class="text-center mb-4">
            <span class="fw-semibold">Last update: </span><span class="text-muted">27/01/2025</span>
          </p>
          <h4 class="text-success">AGREEMENT TO TERMS</h4>
          <p>These Terms and Conditions constitute a legally binding agreement made between <span
              class="text-success fw-semibold">you</span>, whether
            personally or on behalf of an entity ("<span class="text-success fw-semibold">you</span>") and
            Eurac Research ("<span class="text-secondary fw-semibold">we</span>," "<span
                class="text-secondary fw-semibold">us</span>" or "<span
                class="text-secondary fw-semibold">our</span>"),
            concerning <span class="text-success fw-semibold">your</span> access to and use of the <span
                class="fw-semibold">{{ this.domain }}</span>
            website (the "<span class="text-primary fw-semibold">Site</span>").</p>

          <p><span class="text-success fw-semibold">You</span> agree that by accessing the <span
              class="text-primary fw-semibold">Site</span>, <span
              class="text-success fw-semibold">you</span> have read, understood, and agree to be bound by
            all of
            these Terms and Conditions. If <span class="text-success fw-semibold">you</span> do not agree
            with all of these Terms and Conditions, then <span class="text-success fw-semibold">you</span>
            are expressly prohibited from using the <span class="text-primary fw-semibold">Site</span> and
            <span class="text-success fw-semibold">you</span> must discontinue use immediately.</p>

          <p>Supplemental terms and conditions or documents that may be posted on the <span
              class="text-primary fw-semibold">Site</span> from time to time
            are hereby expressly incorporated herein by reference. <span class="text-secondary fw-semibold">We</span>
            reserve the right, in <span class="text-secondary fw-semibold">our</span> sole
            discretion, to make changes or modifications to these Terms and Conditions at any time and for
            any reason.</p>

          <p><span class="text-secondary fw-semibold">We</span> will alert <span
              class="text-success fw-semibold">you</span> about any changes by updating the
            "Last updated" date of these Terms and
            Conditions, and <span class="text-success fw-semibold">you</span> waive any right to receive
            specific notice of each such change.</p>

          <p>It is <span class="text-success fw-semibold">your</span> responsibility to periodically review
            these Terms and Conditions to stay informed of
            updates. <span class="text-success fw-semibold">You</span> will be subject to, and will be
            deemed to have been made aware of and to have
            accepted, the changes in any revised Terms and Conditions by <span
                class="text-success fw-semibold">your</span> continued use of the <span
                class="text-primary fw-semibold">Site</span>
            after the date such revised Terms and Conditions are posted.</p>

          <p>The information provided on the <span class="text-primary fw-semibold">Site</span> is not
            intended for distribution to or use by any person or
            entity in any jurisdiction or country where such distribution or use would be contrary to law or
            regulation or which would subject <span class="text-secondary fw-semibold">us</span> to any
            registration requirement within such jurisdiction or
            country.</p>

          <p>Accordingly, those persons who choose to access the <span
              class="text-primary fw-semibold">Site</span> from other locations do so on their own
            initiative and are solely responsible for compliance with local laws, if and to the extent local
            laws are applicable.</p>

          <p>The <span class="text-primary fw-semibold">Site</span> is intended for users who are at least 18
            years old. Persons under the age of 18 are not
            permitted to register for the <span class="text-primary fw-semibold">Site</span>.</p>

          <h4 class="text-success">INTELLECTUAL PROPERTY RIGHTS</h4>
          <p>Unless otherwise indicated, the <span class="text-primary fw-semibold">Site</span> is <span
              class="text-secondary fw-semibold">our</span>
            proprietary property and all source code, databases,
            functionality, software, website designs, audio, video, text, photographs, and graphics on the
            <span class="text-primary fw-semibold">Site</span> (collectively, the "Content") and the
            trademarks, service marks, and logos contained
            therein (the "Marks") are owned or controlled by <span
                class="text-secondary fw-semibold">us</span> or licensed to <span
                class="text-secondary fw-semibold">us</span>, and are protected by
            copyright and trademark laws.</p>
          <p>The Content and the Marks are provided on the <span class="text-primary fw-semibold">Site</span>
            "AS IS" for <span class="text-success fw-semibold">your</span> information and personal use
            only. Except as expressly provided in these Terms and Conditions, no part of the <span
                class="text-primary fw-semibold">Site</span> and no
            Content or Marks may be copied, reproduced, aggregated, republished, uploaded, posted, publicly
            displayed, encoded, translated, transmitted, distributed, sold, licensed, or otherwise exploited
            for any commercial purpose whatsoever, without <span
                class="text-secondary fw-semibold">our</span> express prior written permission.</p>
          <p>Provided that <span class="text-success fw-semibold">you</span> are eligible to use the <span
              class="text-primary fw-semibold">Site</span>, <span
              class="text-success fw-semibold">you</span> are granted a limited license to access and
            use the <span class="text-primary fw-semibold">Site</span> and to download or print a copy of
            any portion of the Content to which <span class="text-success fw-semibold">you</span> have
            properly gained access solely for <span class="text-success fw-semibold">your</span> personal,
            non-commercial use. <span class="text-secondary fw-semibold">We</span> reserve all rights not
            expressly granted to <span class="text-success fw-semibold">you</span> in and to the <span
                class="text-primary fw-semibold">Site</span>, the Content and the Marks.</p>

          <h4 class="text-success">USER REPRESENTATIONS</h4>
          <p>By using the <span class="text-primary fw-semibold">Site</span>, <span
              class="text-success fw-semibold">you</span> represent and warrant that:</p>
          <p>
            <ol>
              <li>all registration information <span class="text-success fw-semibold">you</span> submit
                will be true, accurate, current, and complete;
              </li>
              <li><span class="text-success fw-semibold">you</span> will maintain the accuracy of such
                information and promptly update such registration
                information as necessary;
              </li>
              <li><span class="text-success fw-semibold">you</span> have the legal capacity and <span
                  class="text-success fw-semibold">you</span> agree to comply with these Terms and
                Conditions;
              </li>
              <li>not a minor in the jurisdiction in which <span
                  class="text-success fw-semibold">you</span> reside;
              </li>
              <li><span class="text-success fw-semibold">you</span> will not access the <span
                  class="text-primary fw-semibold">Site</span> through automated or non-human means,
                whether through a
                bot, script, or otherwise;
              </li>
              <li><span class="text-success fw-semibold">you</span> will not use the <span
                  class="text-primary fw-semibold">Site</span> for any illegal or unauthorized
                purpose;
              </li>
              <li><span class="text-success fw-semibold">your</span> use of the <span
                  class="text-primary fw-semibold">Site</span> will not violate any applicable law or
                regulation.
              </li>
            </ol>
          </p>
          <p>If <span class="text-success fw-semibold">you</span> provide any information that is untrue,
            inaccurate, not current, or incomplete, <span class="text-secondary fw-semibold">we</span> have
            the right to suspend or terminate <span class="text-success fw-semibold">your</span> account and
            refuse any and all current or future use of
            the <span class="text-primary fw-semibold">Site</span> (or any portion thereof).</p>

          <h4 class="text-success">USER REGISTRATION</h4>
          <p><span class="text-success fw-semibold">You</span> may be required to register with the <span
              class="text-primary fw-semibold">Site</span>. <span
              class="text-success fw-semibold">You</span> agree to keep <span
              class="text-success fw-semibold">your</span> password confidential and
            will be responsible for all use of <span class="text-success fw-semibold">your</span> account
            and password. <span class="text-secondary fw-semibold">We</span> reserve the right to remove,
            reclaim, or change a username <span class="text-success fw-semibold">you</span> select if <span
                class="text-secondary fw-semibold">we</span>
            determine, in <span class="text-secondary fw-semibold">our</span> sole discretion, that such
            username is inappropriate, obscene, or otherwise objectionable.</p>

          <h4 class="text-success">PROHIBITED ACTIVITIES</h4>
          <p><span class="text-success fw-semibold">You</span> may not access or use the <span
              class="text-primary fw-semibold">Site</span> for any purpose other than that for which <span
              class="text-secondary fw-semibold">we</span>
            make the <span class="text-primary fw-semibold">Site</span>
            available. The <span class="text-primary fw-semibold">Site</span> may not be used in connection
            with any commercial endeavors except those
            that are specifically endorsed or approved by <span class="text-secondary fw-semibold">us</span>.
          </p>
          <p>As a user of the <span class="text-primary fw-semibold">Site</span>, <span
              class="text-success fw-semibold">you</span> agree not to:</p>
          <ol>
            <li>systematically retrieve data or other content from the <span
                class="text-primary fw-semibold">Site</span> to create or compile, directly
              or indirectly, a collection, compilation, database, or directory without written permission
              from <span class="text-secondary fw-semibold">us</span>.
            </li>
            <li>make any unauthorized use of the <span class="text-primary fw-semibold">Site</span>,
              including collecting usernames and/or email addresses
              of users by electronic or other means for the purpose of sending unsolicited email, or
              creating user accounts by automated means or under false pretenses.
            </li>
            <li>use the <span class="text-primary fw-semibold">Site</span> to advertise or offer to sell
              goods and services.
            </li>
            <li>circumvent, disable, or otherwise interfere with security-related features of the <span
                class="text-primary fw-semibold">Site</span>,
              including features that prevent or restrict the use or copying of any Content or enforce
              limitations on the use of the <span class="text-primary fw-semibold">Site</span> and/or the
              Content contained therein.
            </li>
            <li>engage in unauthorized framing of or linking to the <span class="text-primary fw-semibold">Site</span>.
            </li>
            <li>trick, defraud, or mislead <span class="text-secondary fw-semibold">us</span> and other
              users, especially in any attempt to learn sensitive
              account information such as user passwords;
            </li>
            <li>make improper use of <span class="text-secondary fw-semibold">our</span> support services or
              submit false reports of abuse or misconduct.
            </li>
            <li>engage in any automated use of the system, such as using scripts to send comments or
              messages, or using any data mining, robots, or similar data gathering and extraction tools.
            </li>
            <li>interfere with, disrupt, or create an undue burden on the <span
                class="text-primary fw-semibold">Site</span> or the networks or services
              connected to the <span class="text-primary fw-semibold">Site</span>.
            </li>
            <li>attempt to impersonate another user or person or use the username of another user.</li>
            <li>sell or otherwise transfer <span class="text-success fw-semibold">your</span> profile.</li>
            <li>use any information obtained from the <span class="text-primary fw-semibold">Site</span> in
              order to harass, abuse, or harm another
              person.
            </li>
            <li>use the <span class="text-primary fw-semibold">Site</span> as part of any effort to compete
              with <span class="text-secondary fw-semibold">us</span> or otherwise use the <span
                  class="text-primary fw-semibold">Site</span> and/or the
              Content for any revenue-generating endeavor or commercial enterprise.
            </li>
            <li>decipher, decompile, disassemble, or reverse engineer any of the software comprising or in
              any way making up a part of the <span class="text-primary fw-semibold">Site</span>.
            </li>
            <li>attempt to bypass any measures of the <span class="text-primary fw-semibold">Site</span>
              designed to prevent or restrict access to the
              <span class="text-primary fw-semibold">Site</span>, or any portion of the <span
                  class="text-primary fw-semibold">Site</span>.
            </li>
            <li>harass, annoy, intimidate, or threaten any of <span
                class="text-secondary fw-semibold">our</span> employees or agents engaged in providing
              any portion of the <span class="text-primary fw-semibold">Site</span> to <span
                  class="text-success fw-semibold">you</span>.
            </li>
            <li>delete the copyright or other proprietary rights notice from any Content.</li>
            <li>copy or adapt the <span class="text-primary fw-semibold">Site</span>’s software, including
              but not limited to HTML, JavaScript, or other
              code.
            </li>
            <li>upload or transmit (or attempt to upload or to transmit) viruses, Trojan horses, or other
              material, including excessive use of capital letters and spamming (continuous posting of
              repetitive text), that interferes with any party’s uninterrupted use and enjoyment of the
              <span class="text-primary fw-semibold">Site</span> or modifies, impairs, disrupts, alters,
              or interferes with the use, features,
              functions, operation, or maintenance of the <span
                  class="text-primary fw-semibold">Site</span>.
            </li>
            <li>upload or transmit (or attempt to upload or to transmit) any material that acts as a passive
              or active information collection or transmission mechanism, including without limitation,
              clear graphics interchange formats ("gifs"), 1×1 pixels, web bugs, cookies, or other similar
              devices (sometimes referred to as "spyware" or "passive collection mechanisms" or "pcms").
            </li>
            <li>except as may be the result of standard search engine or Internet browser usage, use,
              launch, develop, or distribute any automated system, including without limitation, any
              spider, robot, cheat utility, scraper, or offline reader that accesses the <span
                  class="text-primary fw-semibold">Site</span>, or using or
              launching any unauthorized script or other software.
            </li>
            <li>disparage, tarnish, or otherwise harm, in <span
                class="text-secondary fw-semibold">our</span> opinion, <span
                class="text-secondary fw-semibold">us</span> and/or the <span
                class="text-primary fw-semibold">Site</span>.
            </li>
            <li>use the <span class="text-primary fw-semibold">Site</span> in a manner inconsistent with any
              applicable laws or regulations.
            </li>
          </ol>

          <h4 class="text-success">USER GENERATED CONTRIBUTIONS</h4>
          <p>The <span class="text-primary fw-semibold">Site</span> may provide <span
              class="text-success fw-semibold">you</span> with the opportunity to create, submit, post,
            display, transmit,
            perform, publish, distribute, or broadcast content and materials to <span
                class="text-secondary fw-semibold">us</span> or on the <span
                class="text-primary fw-semibold">Site</span>, including
            but not limited to text, writings, comments, suggestions, or personal information or other
            material (collectively, "Contributions").</p>
          <p>Contributions may be viewable by the administrators of the <span
              class="text-primary fw-semibold">Site</span>. As such, any Contributions <span
              class="text-success fw-semibold">you</span> transmit
            may be treated as non-confidential and non-proprietary. When <span
                class="text-success fw-semibold">you</span> create or make available any
            Contributions, <span class="text-success fw-semibold">you</span> thereby represent and warrant
            that:</p>
          <ol>
            <li>the creation, distribution, transmission, public display, or performance, and the accessing,
              downloading, or copying of <span class="text-success fw-semibold">your</span> Contributions
              do not and will not infringe the proprietary
              rights, including but not limited to the copyright, patent, trademark, trade secret, or
              moral rights of any third party.
            </li>
            <li><span class="text-success fw-semibold">you</span> are the creator and owner of or have the
              necessary licenses, rights, consents, releases,
              and permissions to use and to authorize <span class="text-secondary fw-semibold">us</span>,
              the <span
                  class="text-primary fw-semibold">Site</span>, and other users of the <span
                  class="text-primary fw-semibold">Site</span> to use
              <span class="text-success fw-semibold">your</span> Contributions in any manner contemplated
              by the <span class="text-primary fw-semibold">Site</span> and these Terms and Conditions.
            </li>
            <li><span class="text-success fw-semibold">you</span> have the written consent, release, and/or
              permission of each and every identifiable
              individual person in <span class="text-success fw-semibold">your</span> Contributions to use
              the name or likeness of each and every such
              identifiable individual person to enable inclusion and use of <span
                  class="text-success fw-semibold">your</span> Contributions in any
              manner contemplated by the <span class="text-primary fw-semibold">Site</span> and these
              Terms and Conditions.
            </li>
            <li><span class="text-success fw-semibold">your</span> Contributions are not false, inaccurate,
              or misleading.
            </li>
            <li><span class="text-success fw-semibold">your</span> Contributions are not unsolicited or
              unauthorized advertising, promotional materials,
              pyramid schemes, chain letters, spam, mass mailings, or other forms of solicitation.
            </li>
            <li><span class="text-success fw-semibold">your</span> Contributions are not obscene, lewd,
              lascivious, filthy, violent, harassing, libelous,
              slanderous, or otherwise objectionable (as determined by <span
                  class="text-secondary fw-semibold">us</span>).
            </li>
            <li><span class="text-success fw-semibold">your</span> Contributions do not ridicule, mock,
              disparage, intimidate, or abuse anyone.
            </li>
            <li><span class="text-success fw-semibold">your</span> Contributions do not advocate the violent
              overthrow of any government or incite,
              encourage, or threaten physical harm against another.
            </li>
            <li><span class="text-success fw-semibold">your</span> Contributions do not violate any
              applicable law, regulation, or rule.
            </li>
            <li><span class="text-success fw-semibold">your</span> Contributions do not violate the privacy
              or publicity rights of any third party.
            </li>
            <li><span class="text-success fw-semibold">your</span> Contributions do not otherwise violate,
              or link to material that violates, any
              provision of these Terms and Conditions, or any applicable law or regulation.
            </li>
          </ol>
          <p>Any use of the <span class="text-primary fw-semibold">Site</span> in violation of the foregoing
            violates these Terms and Conditions and may
            result in, among other things, termination or suspension of <span
                class="text-success fw-semibold">your</span> rights to use the <span
                class="text-primary fw-semibold">Site</span>.</p>

          <h4 class="text-success">CONTRIBUTION LICENSE</h4>
          <p>By posting <span class="text-success fw-semibold">your</span> Contributions to any part of the
            <span class="text-primary fw-semibold">Site</span>, <span
                class="text-success fw-semibold">you</span> automatically grant, and <span
                class="text-success fw-semibold">you</span> represent
            and warrant that <span class="text-success fw-semibold">you</span> have the right to grant, to
            <span class="text-secondary fw-semibold">us</span> an unrestricted, unlimited, irrevocable,
            perpetual, non-exclusive, transferable, royalty-free, fully-paid, worldwide right, and license
            to host, use, copy, reproduce, disclose, sell, resell, publish, broadcast, retitle, archive,
            store, cache, publicly perform, publicly display, reformat, translate, transmit, excerpt (in
            whole or in part), and distribute such Contributions (including, without limitation, <span
                class="text-success fw-semibold">your</span> image
            and voice) for any purpose, commercial, advertising, or otherwise, and to prepare derivative
            works of, or incorporate into other works, such Contributions, and grant and authorize
            sublicenses of the foregoing. The use and distribution may occur in any media formats and
            through any media channels.</p>
          <p>This license will apply to any form, media, or technology now known or hereafter developed, and
            includes <span class="text-secondary fw-semibold">our</span> use of <span
                class="text-success fw-semibold">your</span> name, company name, and
            franchise name, as applicable, and any of the
            trademarks, service marks, trade names, logos, and personal and commercial images <span
                class="text-success fw-semibold">you</span> provide.
            <span class="text-success fw-semibold">You</span> waive all moral rights in <span
                class="text-success fw-semibold">your</span> Contributions, and <span
                class="text-success fw-semibold">you</span> warrant that moral rights have not
            otherwise been asserted in <span class="text-success fw-semibold">your</span> Contributions.</p>
          <p><span class="text-secondary fw-semibold">We</span> do not assert any ownership over <span
              class="text-success fw-semibold">your</span>
            Contributions. <span class="text-success fw-semibold">You</span> retain full ownership of all of
            <span class="text-success fw-semibold">your</span>
            Contributions and any intellectual property rights or other proprietary rights associated with
            <span class="text-success fw-semibold">your</span> Contributions. <span
                class="text-secondary fw-semibold">We</span> are not liable for any
            statements or representations in <span class="text-success fw-semibold">your</span>
            Contributions provided by <span class="text-success fw-semibold">you</span> in any area on the
            <span class="text-primary fw-semibold">Site</span>.</p>
          <p><span class="text-success fw-semibold">You</span> are solely responsible for <span
              class="text-success fw-semibold">your</span> Contributions to the <span
              class="text-primary fw-semibold">Site</span> and <span
              class="text-success fw-semibold">you</span> expressly agree to
            exonerate <span class="text-secondary fw-semibold">us</span> from any and all responsibility and
            to refrain from any legal action against <span class="text-secondary fw-semibold">us</span>
            regarding <span class="text-success fw-semibold">your</span> Contributions.</p>
          <p><span class="text-secondary fw-semibold">We</span> have the right, in <span
              class="text-secondary fw-semibold">our</span> sole and absolute discretion, (1) to edit,
            redact, or otherwise change
            any Contributions; (2) to re-categorize any Contributions to place them in more appropriate
            locations on the <span class="text-primary fw-semibold">Site</span>; and (3) to pre-screen or
            delete any Contributions at any time and for any
            reason, without notice. <span class="text-secondary fw-semibold">We</span> have no obligation to
            monitor <span class="text-success fw-semibold">your</span>
            Contributions.</p>

          <h4 class="text-success">SUBMISSIONS</h4>
          <p><span class="text-success fw-semibold">You</span> acknowledge and agree that any questions,
            comments, suggestions, ideas, feedback, or other
            information regarding the <span class="text-primary fw-semibold">Site</span> ("Submissions")
            provided by <span class="text-success fw-semibold">you</span> to <span
                class="text-secondary fw-semibold">us</span> are non-confidential and
            shall become <span class="text-secondary fw-semibold">our</span> sole property. <span
                class="text-secondary fw-semibold">We</span> shall own exclusive rights, including all
            intellectual
            property rights, and shall be entitled to the unrestricted use and dissemination of these
            Submissions for any lawful purpose, commercial or otherwise, without acknowledgment or
            compensation to <span class="text-success fw-semibold">you</span>.</p>
          <p><span class="text-success fw-semibold">You</span> hereby waive all moral rights to any such
            Submissions, and <span class="text-success fw-semibold">you</span> hereby warrant that any such
            Submissions are original with <span class="text-success fw-semibold">you</span> or that <span
                class="text-success fw-semibold">you</span> have the right to submit such Submissions.
            <span class="text-success fw-semibold">You</span>
            agree there shall be no recourse against <span class="text-secondary fw-semibold">us</span> for
            any alleged or actual infringement or
            misappropriation of any proprietary right in <span class="text-success fw-semibold">your</span>
            Submissions.</p>

          <h4 class="text-success">SITE MANAGEMENT</h4>
          <p><span class="text-secondary fw-semibold">We</span> reserve the right, but not the obligation, to:
          </p>
          <ol>
            <li>monitor the <span class="text-primary fw-semibold">Site</span> for violations of these Terms
              and Conditions;
            </li>
            <li>take appropriate legal action against anyone who, in <span
                class="text-secondary fw-semibold">our</span> sole discretion, violates the law
              or these Terms and Conditions, including without limitation, reporting such user to law
              enforcement authorities;
            </li>
            <li>in <span class="text-secondary fw-semibold">our</span> sole discretion and without
              limitation, refuse, restrict access to, limit the
              availability of, or disable (to the extent technologically feasible) any of <span
                  class="text-success fw-semibold">your</span>
              Contributions or any portion thereof;
            </li>
            <li>in <span class="text-secondary fw-semibold">our</span> sole discretion and without
              limitation, notice, or liability, to remove from the
              <span class="text-primary fw-semibold">Site</span>
              or otherwise disable all files and content that are excessive in size or are in any way
              burdensome to <span class="text-secondary fw-semibold">our</span> systems;
            </li>
            <li>otherwise manage the <span class="text-primary fw-semibold">Site</span> in a manner designed
              to protect <span class="text-secondary fw-semibold">our</span> rights and property and to
              facilitate the proper functioning of the <span class="text-primary fw-semibold">Site</span>.
            </li>
          </ol>

          <h4 class="text-success">PRIVACY POLICY</h4>
          <p><span class="text-secondary fw-semibold">We</span> care about data privacy and security. Please
            review <span class="text-secondary fw-semibold">our</span> Privacy Policy
            <router-link :to="{name: this.privacyLink}" target="_blank">here</router-link>
            . By using the
            <span class="text-primary fw-semibold">Site</span>, <span
                class="text-success fw-semibold">you</span> agree to be bound by <span
                class="text-secondary fw-semibold">our</span> Privacy
            Policy, which is incorporated into these Terms and Conditions.
          </p>

          <h4 class="text-success">TERM AND TERMINATION</h4>
          <p>These Terms and Conditions shall remain in full force and effect while <span
              class="text-success fw-semibold">you</span> use the <span class="text-primary fw-semibold">Site</span>.
            Without
            limiting any other provision of these terms and conditions, <span
                class="text-secondary fw-semibold">we</span> reserve the right to, in <span
                class="text-secondary fw-semibold">our</span> sole
            discretion and without notice or liability, deny access to and use of the <span
                class="text-primary fw-semibold">Site</span> (including
            blocking certain IP addresses), to any person for any reason or for no reason, including without
            limitation for breach of any representation, warranty, or covenant contained in these terms and
            conditions or of any applicable law or regulation. <span
                class="text-secondary fw-semibold">we</span> may terminate <span
                class="text-success fw-semibold">your</span> use or participation in
            the <span class="text-primary fw-semibold">Site</span> or delete <span
                class="text-success fw-semibold">your</span> account and any content or information that
            <span class="text-success fw-semibold">you</span> posted at any time,
            without warning, in <span class="text-secondary fw-semibold">our</span> sole discretion.</p>
          <p>If <span class="text-secondary fw-semibold">we</span> terminate or suspend <span
              class="text-success fw-semibold">your</span> account for any
            reason, <span class="text-success fw-semibold">you</span> are prohibited from registering and
            creating a new account under <span class="text-success fw-semibold">your</span> name, a fake or
            borrowed name, or the name of any third party,
            even if <span class="text-success fw-semibold">you</span> may be acting on behalf of the third
            party.</p>
          <p>In addition to terminating or suspending <span class="text-success fw-semibold">your</span>
            account, <span class="text-secondary fw-semibold">we</span> reserve the right to take
            appropriate
            legal action, including without limitation pursuing civil, criminal, and injunctive redress.</p>

          <h4 class="text-success">MODIFICATIONS AND INTERRUPTIONS</h4>
          <p><span class="text-secondary fw-semibold">We</span> reserve the right to change, modify, or remove
            the contents of the <span
                class="text-primary fw-semibold">Site</span> at any time or for any
            reason at <span class="text-secondary fw-semibold">our</span> sole discretion without notice.
            However, <span class="text-secondary fw-semibold">we</span> have no obligation to update any
            information on <span class="text-secondary fw-semibold">our</span> <span
                class="text-primary fw-semibold">Site</span>. <span class="text-secondary fw-semibold">We</span>
            also reserve the right
            to modify or discontinue all or part of the
            <span class="text-primary fw-semibold">Site</span> without notice at any time.</p>
          <p><span class="text-secondary fw-semibold">We</span> will not be liable to <span
              class="text-success fw-semibold">you</span> or any third party for
            any modification, price change, suspension,
            or discontinuance of the <span class="text-primary fw-semibold">Site</span>.</p>
          <p><span class="text-secondary fw-semibold">We</span> cannot guarantee the <span
              class="text-primary fw-semibold">Site</span> will be available at
            all times. <span class="text-secondary fw-semibold">We</span> may experience hardware,
            software, or other problems or need to perform maintenance related to the <span
                class="text-primary fw-semibold">Site</span>, resulting in
            interruptions, delays, or errors.</p>
          <p><span class="text-secondary fw-semibold">We</span> reserve the right to change, revise, update,
            suspend, discontinue, or otherwise modify the
            <span class="text-primary fw-semibold">Site</span> at any time or for any reason without notice
            to <span class="text-success fw-semibold">you</span>. <span
                class="text-success fw-semibold">You</span> agree that <span
                class="text-secondary fw-semibold">we</span> have no liability
            whatsoever for any loss, damage, or inconvenience caused by <span
                class="text-success fw-semibold">your</span> inability to access or use the
            <span class="text-primary fw-semibold">Site</span> during any downtime or discontinuance of the
            <span class="text-primary fw-semibold">Site</span>.</p>
          <p>Nothing in these Terms and Conditions will be construed to obligate <span
              class="text-secondary fw-semibold">us</span> to maintain and support
            the <span class="text-primary fw-semibold">Site</span> or to supply any corrections, updates, or
            releases in connection therewith.</p>

          <h4 class="text-success">GOVERNING LAW</h4>
          <p>These Terms and Conditions and <span class="text-success fw-semibold">your</span> use of the
            <span class="text-primary fw-semibold">Site</span> are governed by and construed in accordance
            with the laws of Italy.</p>

          <h4 class="text-success">DISPUTE RESOLUTION</h4>
          <p>Any legal action of whatever nature brought by either <span
              class="text-success fw-semibold">you</span> or <span
              class="text-secondary fw-semibold">us</span> (collectively, the "Parties" and
            individually, a "Party") shall be commenced or prosecuted in Italy.</p>

          <h4 class="text-success">CORRECTIONS</h4>
          <p>There may be information on the <span class="text-primary fw-semibold">Site</span> that contains
            typographical errors, inaccuracies, or
            omissions that may relate to the <span class="text-primary fw-semibold">Site</span>, including
            descriptions, pricing, availability, and
            various other information. <span class="text-secondary fw-semibold">We</span> reserve the right
            to correct any errors, inaccuracies, or
            omissions and to change or update the information on the <span class="text-primary fw-semibold">Site</span>
            at any time, without prior
            notice.</p>

          <h4 class="text-success">DISCLAIMER</h4>
          <p>The <span class="text-primary fw-semibold">Site</span> is provided on an as-is and as-available
            basis. <span class="text-success fw-semibold">you</span> agree that <span
                class="text-success fw-semibold">your</span> use of the <span
                class="text-primary fw-semibold">Site</span> and
            <span class="text-secondary fw-semibold">our</span> services will be at <span
                class="text-success fw-semibold">your</span> sole risk. To the
            fullest extent permitted by law, <span class="text-secondary fw-semibold">we</span> disclaim all
            warranties, express or implied, in connection with the <span class="text-primary fw-semibold">Site</span>
            and <span class="text-success fw-semibold">your</span> use thereof, including,
            without limitation, the implied warranties of merchantability, fitness for a particular purpose,
            and non-infringement. <span class="text-secondary fw-semibold">we</span> make no warranties or
            representations about the accuracy or
            completeness of the <span class="text-primary fw-semibold">Site</span>’s content or the content
            of any websites linked to the <span class="text-primary fw-semibold">Site</span> and <span
                class="text-secondary fw-semibold">we</span> will
            assume no liability or responsibility for any (1) errors, mistakes, or inaccuracies of content
            and materials, (2) personal injury or property damage, of any nature whatsoever, resulting from
            <span class="text-success fw-semibold">your</span> access to and use of the <span
                class="text-primary fw-semibold">Site</span>, (3) any unauthorized access to or use of
            <span class="text-secondary fw-semibold">our</span> secure servers
            and/or any and all personal information and/or financial information stored therein, (4) any
            interruption or cessation of transmission to or from the <span class="text-primary fw-semibold">Site</span>,
            (5) any bugs, viruses, trojan
            horses, or the like which may be transmitted to or through the <span
                class="text-primary fw-semibold">Site</span> by any third party, and/or
            (6) any errors or omissions in any content and materials or for any loss or damage of any kind
            incurred as a result of the use of any content posted, transmitted, or otherwise made available
            via the <span class="text-primary fw-semibold">Site</span>.</p>

          <h4 class="text-success">LIMITATIONS OF LIABILITY</h4>
          <p>In no event will <span class="text-secondary fw-semibold">we</span> or <span
              class="text-secondary fw-semibold">our</span> directors, employees, or agents be liable to
            <span
                class="text-success fw-semibold">you</span> or any third party
            for any direct, indirect, consequential, exemplary, incidental, special, or punitive damages,
            including lost profit, lost revenue, loss of data, or other damages arising from <span
                class="text-success fw-semibold">your</span> use of the
            <span class="text-primary fw-semibold">Site</span>, even if <span
                class="text-secondary fw-semibold">we</span> have been advised of the
            possibility of such damages.</p>

          <h4 class="text-success">INDEMNIFICATION</h4>
          <p><span class="text-success fw-semibold">You</span> agree to defend, indemnify, and hold <span
              class="text-secondary fw-semibold">us</span>
            harmless, including <span class="text-secondary fw-semibold">our</span> subsidiaries,
            affiliates, and
            all of <span class="text-secondary fw-semibold">our</span> respective officers, agents,
            partners, and employees, from and against any loss,
            damage, liability, claim, or demand, including reasonable attorneys’ fees and expenses, made by
            any third party due to or arising out of: (1) <span class="text-success fw-semibold">your</span>
            Contributions; (2) use of the <span class="text-primary fw-semibold">Site</span>; (3)
            breach of these Terms and Conditions; (4) any breach of <span class="text-success fw-semibold">your</span>
            representations and warranties set
            forth in these Terms and Conditions; (5) <span class="text-success fw-semibold">your</span>
            violation of the rights of a third party,
            including but not limited to intellectual property rights; or (6) any overt harmful act toward
            any other user of the <span class="text-primary fw-semibold">Site</span> with whom <span
                class="text-success fw-semibold">you</span> connected via the <span
                class="text-primary fw-semibold">Site</span>.</p>
          <p>Notwithstanding the foregoing, <span class="text-secondary fw-semibold">we</span> reserve the
            right, at <span class="text-success fw-semibold">your</span>
            expense, to assume the exclusive
            defense and control of any matter for which <span class="text-success fw-semibold">you</span>
            are required to indemnify <span class="text-secondary fw-semibold">us</span>, and <span
                class="text-success fw-semibold">you</span> agree to
            cooperate, at <span class="text-success fw-semibold">your</span> expense, with <span
                class="text-secondary fw-semibold">our</span> defense of
            such claims. <span class="text-secondary fw-semibold">We</span> will use reasonable efforts to
            notify <span class="text-success fw-semibold">you</span> of any such claim, action, or
            proceeding which is subject to this indemnification
            upon becoming aware of it.</p>

          <h4 class="text-success">USER DATA</h4>
          <p><span class="text-secondary fw-semibold">We</span> will maintain certain data that <span
              class="text-success fw-semibold">you</span> transmit to
            the <span class="text-primary fw-semibold">Site</span> for the purpose of managing the <span
                class="text-primary fw-semibold">Site</span>,
            as well as data relating to <span class="text-success fw-semibold">your</span> use of the <span
                class="text-primary fw-semibold">Site</span>. Although <span
                class="text-secondary fw-semibold">we</span> perform regular routine
            backups of
            data, <span class="text-success fw-semibold">you</span> are solely responsible for all data that
            <span class="text-success fw-semibold">you</span> transmit or that relates to any activity
            <span class="text-success fw-semibold">you</span> have undertaken using the <span
                class="text-primary fw-semibold">Site</span>.</p>
          <p><span class="text-success fw-semibold">You</span> agree that <span
              class="text-secondary fw-semibold">we</span> shall have no liability to <span
              class="text-success fw-semibold">you</span> for any loss or corruption of any such data, and
            <span class="text-success fw-semibold">you</span> hereby waive any right of action against <span
                class="text-secondary fw-semibold">us</span>
            arising from any such loss or corruption of such
            data.</p>

          <h4 class="text-success">MISCELLANEOUS</h4>
          <p>These Terms and Conditions and any policies or operating rules posted by <span
              class="text-secondary fw-semibold">us</span> on the <span
              class="text-primary fw-semibold">Site</span>
            constitute the entire agreement and understanding between <span
                class="text-success fw-semibold">you</span> and <span
                class="text-secondary fw-semibold">us</span>. <span class="text-secondary fw-semibold">Our</span>
            failure to exercise or
            enforce any right or provision of these Terms and Conditions shall not operate as a waiver of
            such right or provision.</p>
          <p>These Terms and Conditions operate to the fullest extent permissible by law. <span
              class="text-secondary fw-semibold">We</span> may assign any or
            all of <span class="text-secondary fw-semibold">our</span> rights and obligations to others at
            any time. <span class="text-secondary fw-semibold">We</span> shall not be responsible or liable
            for any loss, damage, delay, or failure to act caused by any cause beyond <span
                class="text-secondary fw-semibold">our</span> reasonable
            control.</p>
          <p>If any provision or part of a provision of these Terms and Conditions is determined to be
            unlawful, void, or unenforceable, that provision or part of the provision is deemed severable
            from these Terms and Conditions and does not affect the validity and enforceability of any
            remaining provisions.</p>
          <p>There is no joint venture, partnership, employment or agency relationship created between <span
              class="text-success fw-semibold">you</span> and
            <span class="text-secondary fw-semibold">us</span> as a result of these Terms and Conditions or
            use of the <span
                class="text-primary fw-semibold">Site</span>. <span
                class="text-success fw-semibold">You</span> agree that these Terms and
            Conditions will not be construed against <span class="text-secondary fw-semibold">us</span> by
            virtue of having drafted them.</p>

          <h4 class="text-success">CONTACT US</h4>
          <p>In order to resolve a complaint regarding the <span class="text-primary fw-semibold">Site</span>
            or to receive further information regarding
            use of the <span class="text-primary fw-semibold">Site</span>, please contact <span
                class="text-secondary fw-semibold">us</span> at:</p>

          <ul style="list-style-type:none;padding-left: 0">
            <li>Eurac Research</li>
            <li>Drususallee 1/ Viale Druso 1</li>
            <li>39100 – Bolzano/Bozen - Italy</li>
            <li>Tel: +39 0471 055 055</li>
            <li>Fax: +39 0471 055 099</li>
            <li v-for="email in this.privacyEmail">
              <a :href="`mailto:${email}?subject=${this.privacyEmailSubject}`">{{ email }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </main>

  <!-- Pixel -->
  <Pixel :prop-source="constants.ROUTING.TERMS" v-if="flagUsePixel()===true"/>
</template>